import {
  apiRequest,
  cp3kPeriodList,
  cp3kPeriodInactive,
  cp3kPeriodActive,
} from "../../../../../services/adapters/kepegawaian/cp3kService";

class DataTableRepository {
  fetchRowTable = async (query, cancelToken) => {
    return await apiRequest(
      "get",
      cp3kPeriodList,
      {
        cancelToken: cancelToken,
        params: query,
      },
      true
    );
  };

  fetchInactive = async (query) => {
    return await apiRequest(
      "post",
      cp3kPeriodInactive,
      {
        body: query,
      },
      true
    );
  };

  fetchActive = async (query) => {
    return await apiRequest(
      "post",
      cp3kPeriodActive,
      {
        body: query,
      },
      true
    );
  };
}

export default DataTableRepository;
